import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gugu_user')); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem('gugu_token'));

  const login = async (email, senha) => {
    const { data } = await api.post('/auth/login', { email, senha });
    localStorage.setItem('gugu_token', data.token);
    localStorage.setItem('gugu_user', JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('gugu_token');
    localStorage.removeItem('gugu_user');
    setToken(null);
    setUser(null);
    window.location.href = '/login';
  };

  /** Renova o token silenciosamente. Retorna true em caso de sucesso. */
  const renewSession = async () => {
    try {
      const { data } = await api.post('/auth/refresh');
      localStorage.setItem('gugu_token', data.token);
      localStorage.setItem('gugu_user', JSON.stringify(data.user));
      setToken(data.token);
      setUser(data.user);
      return true;
    } catch {
      return false;
    }
  };

  // Escuta o evento emitido pelo interceptor Axios quando o token expira (401).
  // Limpa o estado React sem forçar window.location.href — evita tela branca.
  useEffect(() => {
    const handleSessionExpired = () => {
      setToken(null);
      setUser(null);
    };
    window.addEventListener('gugu:session-expired', handleSessionExpired);
    return () => window.removeEventListener('gugu:session-expired', handleSessionExpired);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, renewSession, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
